var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/retake_image.5ce9a14c.png","uri@2x": __webpack_public_path__ + "static/media/retake_image.bf987aa0.png","uri@3x": __webpack_public_path__ + "static/media/retake_image.5c37bbd2.png",
    width: 42,
    height: 42
});